import type { Control, FieldValues, Path } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';

interface ReasonFieldProps<T extends FieldValues & { reason: string }> {
  control: Control<T>;
  disabled?: boolean;
}

/**
 * Required ticket reference input for forms that write to the audit log. The form values must
 * include a `reason` string.
 */
export function ReasonField<T extends FieldValues & { reason: string }>({
  control,
  disabled,
}: ReasonFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={'reason' as Path<T>}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="font-bold">
            Ticket{' '}
            <Badge variant="outline" className="ml-1">
              Required
            </Badge>
          </FormLabel>
          <FormControl>
            <Input
              placeholder="e.g. SUP-1234, or a link to the ticket or Slack thread"
              autoComplete="off"
              disabled={disabled}
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
